import React from 'react';

const Footer = () => (
  <footer className="text-muted blog-footer border-top d-none">
    <div className="container">
      <p className="float-right">
        Nerd Fitness Coaching - the best that ever was.
      </p>
    </div>
  </footer>
);

export default Footer;
